import { useEffect, useState } from "react";
import { api, fmtPrice, fmtPct, changeColor } from "../lib/api";
import { Link } from "react-router-dom";

export default function TickerBar() {
  const [quotes, setQuotes] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try { const { data } = await api.get("/commodities/quotes"); if (alive) setQuotes(data); } catch {}
    };
    load();
    const id = setInterval(load, 15000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!quotes.length) return null;
  const doubled = [...quotes, ...quotes];
  return (
    <div data-testid="ticker-bar" className="w-full overflow-hidden border-y border-border/60 bg-card/40 backdrop-blur-md">
      <div className="marquee-track flex whitespace-nowrap py-2">
        {doubled.map((q, i) => (
          <Link
            key={`${q.code}-${i}`}
            to={`/commodity/${q.code}`}
            data-testid={`ticker-${q.code.toLowerCase()}-${i}`}
            className="mx-6 inline-flex items-center gap-3 text-xs font-mono uppercase tracking-wider transition hover:text-primary"
          >
            <span className="font-semibold text-foreground">{q.code}</span>
            <span className="num text-foreground">{fmtPrice(q.price, 2)}</span>
            <span className={changeColor(q.change_pct)}>{fmtPct(q.change_pct)}</span>
            <span className="text-muted-foreground/60">|</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
